import React, {Component} from 'react';

import './Results.css';

import AvatarBaby from './avatars/Baby';

import ColorToHex from './ColorToHex';
import ShadeColorToHex from './ShadeColorToHex';

import hr from './hr.svg';

class Results extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  };

  // componentDidMount() {
  // }

  topResult(results) {
    var max = results.black
    var result = "black"
    if (results.brown > max) {
      max = results.brown
      result = "brown"
    }
    if (results.red > max) {
      max = results.red
      result = "red"
    }
    if (results.strawberry_blonde > max) {
      max = results.strawberry_blonde
      result = "strawberry blonde"
    }
    if (results.blonde > max) {
      max = results.blonde
      result = "blonde"
    }

    return result
  }

  sortedResults(results) {
    var a = []
    a.push({name: 'Black', value: results.black})
    a.push({name: 'Brown', value: results.brown})
    a.push({name: 'Red', value: results.red})
    a.push({name: 'Strawberry Blonde', value: results.strawberry_blonde})
    a.push({name: 'Blonde', value: results.blonde})
    a.sort(function(a, b) {
      return b.value - a.value
    })
    return a
  }

  render() {
    return (
      <div key={JSON.stringify(this.props.results)} className="Predictor-results">
        <h2>Baby hair color</h2>
        <img className="hr large" src={hr} alt="" />
        <div>
          <div className="Predictor-result-tree">
            <div className="Predictor-result-tree-grandparents">
              <div className="Predictor-result-tree-grandparents-maternal">
                <div className={"Predictor-choice-icon Predictor-choice-icon-" + this.props.maternalGrandmother}></div>
                <div className={"Predictor-choice-icon Predictor-choice-icon-" + this.props.maternalGrandfather}></div>
              </div>
              <div className="Predictor-result-tree-grandparents-paternal">
                <div className={"Predictor-choice-icon Predictor-choice-icon-" + this.props.paternalGrandmother}></div>
                <div className={"Predictor-choice-icon Predictor-choice-icon-" + this.props.paternalGrandfather}></div>
              </div>
            </div>
            <div className="Predictor-result-tree-parents">
              <div className={"Predictor-choice-icon Predictor-choice-icon-" + this.props.mother}></div>
              <div className={"Predictor-choice-icon Predictor-choice-icon-" + this.props.father}></div>
            </div>
            <div className="Predictor-result-tree-baby">
              <div className={"Predictor-choice-icon Predictor-choice-icon-" + this.topResult(this.props.results)}></div>
            </div>
          </div>
          <div className="Predictor-result-baby-display">
            { this.sortedResults(this.props.results).map(item =>
              <div key={JSON.stringify(item)} className='Predictor-result-breakdown-container'>
                <div style={{textTransform: 'uppercase', fontSize: '15px', fontWeight: 700}}>{item.name}</div>
                <div style={{fontSize: '2em', fontWeight: 700}}>{item.value ? Math.round(item.value*100)/100 + '%': ''}</div>
                <img className="hr small" src={hr} alt="" />
                <AvatarBaby
                  colorHex={ColorToHex(item.name.toLowerCase())}
                  shadeColorHex={ShadeColorToHex(item.name.toLowerCase())}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Results;
